import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useInView from "../lib/useInView";
import investIMG from "../images/home_bg.png";
import couple from "../images/sky-high-couple.png";
import Carousel from "../components/Carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLandmarkDome,
  faLandmarkFlag,
  faChartPie,
  faCommentsDollar,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import homeBg from "../images/about_img.png";
import loginIMG from "../images/page.webp";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";

const About = () => {
  const navigate = useNavigate();
  const BRAND_NAME = process.env.REACT_APP_BRAND_NAME;

  // word change animations
  const words = ["Banking", "Investments", "e-Loans"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  // Cycle through words every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [words.length]);

  // image animation
  const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
  const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
  const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
  const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
  const [boxSavingRef, boxSavingInView] = useInView({ threshold: 0.5 });
  const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
  const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
  const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
  const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
  const [box9Ref, box9InView] = useInView({ threshold: 0.7 });
  const [box2Ref, box2InView] = useInView({ threshold: 0.7 });
  const [box3Ref, box3InView] = useInView({ threshold: 0.7 });

  return (
    <>
      <div id="hero-section">
        <div className="hero-section">
          {/* Left Box: Text and Sub-Boxes */}
          <div className="hero-text-container">
            <h1 className="hero-title">
              About {BRAND_NAME}{" "}
              <span className="handwriting">{words[currentWordIndex]}</span>
            </h1>
            <p className="hero-description">
              We've grown to become one of the largest digital banking
              providers, committed to inventing, simplifying, and humanizing the
              banking experience.{" "}
            </p>
            <h2 className="hero-description">
              Turn your plans into <span className="circle-text">goals</span>
            </h2>
            <div
              ref={boxSavingRef}
              className={`sub-container animate__animated ${boxSavingInView ? "animate__flipInX" : ""}`}
            >
              <div className="sub-box" onClick={() => navigate("/about-us")}>
                Savings
              </div>
              <div className="sub-box" onClick={() => navigate("/loans")}>
                Loans
              </div>
              <div className="sub-box" onClick={() => navigate("/investments")}>
                Investments
              </div>
            </div>
          </div>

          {/* Right Box: Image */}
          <div className="hero-image-container">
            <img
              src={investIMG}
              alt="Hero"
              ref={box1Ref}
              className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
            />
          </div>
        </div>

        {/* Display Sliding Carousel */}
        <Carousel />
      </div>

      <div className="heading-cover-bg">
        {/* three column content is next */}
        <div className="last-section">
          {/* Box 1: Text */}
          <div className="box">
            <h2 className="box-title" id="white-title">
              Over 150 Support Teams and more than 50 {BRAND_NAME} Partners.{" "}
            </h2>
            <div className="box-text">
              As an Online Banking, we reserve the right to many different
              locations to enable us work online and serve better. Also be aware
              that we may accept deposits and withdrawals using bitcoin or other
              allowed crypto currencies.
            </div>
            <div className="box-text">
              <h3 className="box-title" id="white-title">
                Insurance Policies
              </h3>
              <>
                At {BRAND_NAME}, Our Insurance solutions protect you
                against unexpected expenses from partial or complete damage to
                you or your properties.
              </>
            </div>
          </div>

          {/* Box 2: Image */}
          <div className="box">
            <img
              src={homeBg}
              alt={BRAND_NAME}
              ref={boxImageRef}
              className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
            />
          </div>

          {/* Box 3: Icon, Heading, and Text */}
          <div className="box">
            <div
              ref={box6Ref}
              className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faLandmarkFlag} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">Online Banking</h3>
                <div className="box-text">
                  When you use any of our e-banking products - online banking,
                  credit and debit cards, you are assured of its security. We
                  offer a secure internet banking platforms for online
                  transactions and e-payments.{" "}
                </div>
              </div>
            </div>

            <div
              ref={box4Ref}
              className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faLandmarkDome} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">Loans & Mortgages</h3>
                <div className="box-text">
                  At {BRAND_NAME}, we strive to help you achieve your
                  financial goals with our flexible financing.We've got a
                  variety of mortgage products to choose from which we've built
                  with your needs in mind.{" "}
                </div>
              </div>
            </div>

            <button
              onClick={() => navigate("/contact-us")}
              className="delete-button"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>

      <>
        <div className="three-box-container">
          <div
            ref={box1Ref}
            className={`box box-cover animate__animated ${box1InView ? "animate__zoomIn" : ""}`}
          >
            <FontAwesomeIcon icon={faGlobe} className="box-icon" />
            <h3 className="box-title center" id="white-title">
              International Account
            </h3>
          </div>

          <div
            ref={box2Ref}
            className={`box box-cover animate__animated ${box2InView ? "animate__zoomIn" : ""}`}
          >
            <FontAwesomeIcon icon={faCommentsDollar} className="box-icon" />
            <h3 className="box-title center" id="white-title">
              Money Transfer
            </h3>
          </div>
          <div
            ref={box3Ref}
            className={`box box-cover animate__animated ${box3InView ? "animate__zoomIn" : ""}`}
          >
            <FontAwesomeIcon icon={faChartPie} className="box-icon" />
            <h3 className="box-title center" id="white-title">
              Currency Chart
            </h3>
          </div>
        </div>
      </>

      {/* The sub section */}
      <div className="video-section">
        <div
          ref={boxVidRef}
          className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
        >
          <img src={couple} alt="" className="box-image" />
        </div>

        <div className="hero-text-container">
          <h2 className="box-title"> Care, Clarity, and Confidence</h2>
          <h2 className="hero-title">
            We want to show you what it’s like to be with a bank that cares.
          </h2>

          <button onClick={() => navigate("/login")} className="delete-button">
            Get Started
          </button>
        </div>
      </div>


      {/* next content here */}
      <div className="main-box-cover">
        <h2 className="text-heading centered">
          More Choices - <span> More Possibilities.</span>
        </h2>
        <div className="hero-description centered">
          We offer our clients comprehensive investment solutions that are
          tailored to each particular client’s needs at a specific period of
          time. For 17 years, we have been providing secure and easy offshore
          banking to over 400,000 who live, travel, shop and work arpund the
          world. We make cross-border banking easy and secure.
        </div>
      </div>

      <div className="last-section">
        <div className="box">
          <img
            ref={boxImgRef}
            src={loginIMG}
            alt="Sky High National Trust Bank"
            className={`box-image animate__animated ${boxImgInView ? "animate__pulse" : ""}`}
          />
          <h2 className="text-heading centered">
            Navigate complexity with a trusted capital markets services partner
            at your side
          </h2>
        </div>
        <div className="box">
          <div
            ref={box7Ref}
            className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={mamitoIMG}
              className="boxed-icon"
              alt="WORKING AND INVESTING INTERNATIONALLY"
            />
            <div className="title-text">
              <h2 className="box-title">
                WORKING AND INVESTING INTERNATIONALLY
              </h2>
              <div className="hero-description">
                Explore endless career and investment opportunities – from
                building a thriving career to making smart financial moves in
                one of the world's strongest economies.{" "}
              </div>
            </div>
          </div>

          <div
            ref={box8Ref}
            className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={broIMG}
              className="boxed-icon"
              alt="RELOCATING AND SCHOOLING IN THE ABROAD"
            />
            <div className="title-text">
              <h2 className="box-title">RELOCATING AND SCHOOLING ABROAD.</h2>
              <div className="hero-description">
                Make your move abroad seamless — discover the best schools,
                opportunities, and everything you need for a successful
                transition.
              </div>
            </div>
          </div>

          <div
            ref={box9Ref}
            className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={girlieIMG}
              className="boxed-icon"
              alt="INTERNATIONAL BUSINESS WITH FOREIGNERS"
            />
            <div className="title-text">
              <h2 className="box-title">
                INTERNATIONAL BUSINESS WITH FOREIGNERS
              </h2>
              <div className="hero-description">
                Seamlessly conduct international transactions, manage foreign
                investments, and build strong financial partnerships with global
                banking solutions.{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
